export const isSingleOptInEnabled = (): boolean => process.env.NEXT_PUBLIC_FF_ENABLE_SINGLE_OPTIN === 'true';
